import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "../../assets/css/app.css";
import contactbnr from "../../assets/imgs/contactbnr.jpg";
import "./Contact.css";

function ContactUs() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <motion.div
      className="ConusM"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}

    >  <div className="bcrumb">
    <div className="maxW">
    <div className="breadcrumb">
     <NavLink to="/">Home  </NavLink>/ <span>Contact Us</span>
    </div>
    </div>
    </div>
    <div className="conBnr">
       <img src={contactbnr} alt="women-bnr" />
    </div>
      <div className="maxW">
        <div className="conMn conusMn">
        <div className="conDtls">
            <div className="conInfo">
              <div>
              <h3>Contact Numbers</h3>
              <a href="tel:+911204217856">+91-120-4217856</a>, <a href="tel:+911204209935">4209935</a>
              <a href="tel:+919899188992">+91 9899188992 </a><strong>(Mr. Pratham Sadh)</strong>
              </div>

             <div>
  <h3>E-mail</h3>
  <p><a href="mailto:pratham@prathamstyle.com">pratham@prathamstyle.com</a></p>
</div>


<div>
  <h3>Office & Factory Address</h3>
  <p>
    <a href="https://www.google.com/maps/search/?api=1&query=A-38/2+SITE+4,+SAHIBABAD+INDUSTRIAL+AREA,+GHAZIABAD,+UP,+201010,+INDIA" target="_blank">
      A-38/2 SITE 4, SAHIBABAD INDUSTRIAL AREA,
      GHAZIABAD, (U.P) 201010, INDIA
    </a>
  </p>
</div>

<div>
  <h3>For Direct Contact</h3>
  <p>Contact Person: <strong>(Mr. Manoj Sadh)</strong></p>
  <p>
    <a href="tel:+919811016622">+91 9811016622</a>
  </p>
  <p>
    <a href="mailto:manoj@prathamstyle.com">manoj@prathamstyle.com</a>
  </p>
</div>

            </div>

            <div className="contact-map">
            <iframe
                title="Google Map"
                width="100%"
                height="350px"
                frameBorder="0"
                style={{ border: 0, borderRadius: '8px' }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.4162599300215!2d77.35610377510094!3d28.63442098241312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf029850b1b8b%3A0x7f374b890deaa135!2sA-38%2F2%2C%20Site%204%2C%20Sahibabad%20Industrial%20Area%2C%20Ghaziabad%2C%20Uttar%20Pradesh%20201010%2C%20India!5e0!3m2!1sen!2sin!4v1707078923456!5m2!1sen!2sin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default ContactUs;
